import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Icon from './AppIcon';

export default function ProtectedRoute({ children }) {
  const { user, userProfile, loading, profileLoading } = useAuth();

  if (loading || (user && profileLoading && userProfile === null)) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--color-background)' }}>
        <div className="flex flex-col items-center gap-4">
          <div className="flex items-center justify-center w-14 h-14 rounded-2xl" style={{ background: 'var(--color-accent)' }}>
            <Icon name="Shield" size={28} color="white" strokeWidth={2} />
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Loader2" size={20} color="var(--color-accent)" strokeWidth={2} className="animate-spin" />
            <span className="text-muted-foreground" style={{ fontFamily: '"IBM Plex Sans", sans-serif', fontSize: '0.9375rem' }}>Cargando MetalGuard...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If email not confirmed, redirect to confirmation page
  if (user && !user?.email_confirmed_at) {
    return <Navigate to="/email-confirmation" state={{ email: user?.email }} replace />;
  }

  return children;
}
